import { pcode } from '@/config'
import { myBrowser } from '@/utils/browser'

export default {
  methods: {
    /*
      1. 埋点 公共方法
      @params: 参数
         fnGroup: 功能分组 (对应excel 模块 列) String
         fnName:  功能名称 (对应excel 名称 列) String
         fnCode:  功能编码 String || Number
         extJson: 扩展字段，Object (对应excel 属性 列 需要传递的值)，role 角色字段会统一追加到此参数， 无需每次调用传递
         config:  可配置，Object (如: pcode: 其它产品的 产品码; noGA: true 代表只做IO埋点， 无需GA 埋点)
      @return: null
     */
    async sendLog (fnGroup, fnName, fnCode, extJson = {}) {
      const params = {
        fnGroup,
        fnName,
        fnCode,
        // debug: !(env === 'product'), // 只统计正式环境数据 ?
        pcode // 产品码 成本大数据: 正式 120766 非正式 120770
      }
      Object.assign(extJson, {
        userAgent: navigator.userAgent,
        browser: myBrowser(),
        width: window.screen.width,
        height: window.screen.height
      })
      params.extJson = JSON.stringify(extJson)
      this.$api.home.log(params)
    },
    /*
      1.1 埋点 公共方法
      @params: 参数
         fnCode:  功能编码 String || Number
         extJson: 扩展字段，Object (对应excel 属性 列 需要传递的值)，role 角色字段会统一追加到此参数， 无需每次调用传递
     */
    sentLog (fnCode, extJson = {}) {
      const dicFile = require('@/config/log.json')
      if (dicFile && fnCode && dicFile[fnCode]) {
        const { fnGroup, fnName } = dicFile[fnCode]
        this.sendLog(fnGroup, fnName, fnCode, extJson)
      }
    }
  }
}
